import styled from 'styled-components';

const ContainedImage = styled.img`
    z-index: 1;
    height: inherit;
    max-height: inherit;
`;

export default ContainedImage;
